export const GET_PURCHASEPLANS = '[PurchasePlan Action] Get customers';
export const CONFIRMED_GET_PURCHASEPLANS = '[PurchasePlan Action] Confirmed Get customers';
